import { FC, ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Heading from "shared/Heading/Heading";

export interface HeaderFilterProps {
  tabActive: string;
  tabs: string[];
  heading: ReactNode;
  subHeading?: ReactNode;
  onClickTab?: (item: string) => void;
}

const HeaderFilter: FC<HeaderFilterProps> = ({
  tabActive,
  tabs,
  subHeading = "",
  heading = "🎈 Latest Articles",
  onClickTab,
}) => {
  const navigate = useNavigate();
  const [tabActiveState, setTabActiveState] = useState(tabActive);
  useEffect(() => {
    setTabActiveState(tabActive);
  }, [tabActive]);

  const handleClickTab = (item: string) => {
    onClickTab && onClickTab(item);
    setTabActiveState(item);
  };

  return (
    <div className="flex flex-col mb-8 relative">
      <div className="flex items-center my-2">
        <Heading>
          Explore Our <span className="bg-gradient-to-r from-[#d4af37] to-[#ffd700]

 bg-clip-text text-transparent">Top</span> Cars
        </Heading>
      </div>
      <span className="text-2xl font-semibold">Luxury, Electric, and Economy Vehicles</span>
    </div>
  );
};

export default HeaderFilter;
